import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import { throwFromResponse } from '../lib/apiErrorMessage';
import { userDetailQueryKey } from './useUserDetailQuery';

export interface UserWithdrawalPayload {
  reason?: string | undefined;
}

/**
 * 관리자 회원탈퇴 (ID68). POST /api/admin/v1/users/{userId}/withdraw.
 * 사유(reason)는 선택. BO 모달엔 사유 입력란이 없어 빈 바디({})로 호출한다.
 * 성공 시 회원은 WITHDRAWN 상태가 되며, 목록·상세 쿼리를 무효화한다.
 */
export const useUserWithdrawalMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      userId,
      payload,
    }: {
      userId: string;
      payload?: UserWithdrawalPayload;
    }) => {
      const res = await adminFetch(`/api/admin/v1/users/${userId}/withdraw`, {
        method: 'POST',
        body: JSON.stringify(payload ?? {}),
      });
      if (!res.ok) await throwFromResponse(res, '회원 탈퇴 처리에 실패했습니다.');
    },
    onSuccess: (_data, { userId }) => {
      void qc.invalidateQueries({ queryKey: ['admin', 'users'] });
      void qc.invalidateQueries({ queryKey: userDetailQueryKey(userId) });
    },
  });
};
